import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface SubmitContactUsFormApiParameter extends ApiParameter {
    "Customer #"?:string;
    "First Name"?: string;
    "Last Name"?: string;
    "Company"?: string;
    'Email Address'?: string;
    "Phone Number"?: string;
    "State"?: string;
    "Zip Code"?: string;
    "Supplier"?: string;
    "Model or Series"?: string;
    "Lat"?: number;
    "Long"?: number;
    "Url"?:string;
    "Additional Details on Your Inquiry"?:string;
    "vendor"?:string;
}

export function submitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    return post<SubmitContactUsFormApiParameter>(`api/v2/lead/submit`, parameter);
}
